import { render, staticRenderFns } from "./PrivacySetting.vue?vue&type=template&id=0225ba03"
import script from "./PrivacySetting.vue?vue&type=script&lang=js"
export * from "./PrivacySetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports